import React, {forwardRef, useImperativeHandle,useState} from 'react'
import { Form, Checkbox,Select,Input,DatePicker,Col,Row, InputNumber, Radio, TreeSelect,Divider,ConfigProvider,Upload,Modal, Button  } from 'antd';
import { PlusOutlined,UploadOutlined } from '@ant-design/icons';
import { getAuthorization } from '@/common/js/utils';
const Option = Select.Option;
const { TreeNode } = TreeSelect;
import  zhCN  from  'antd/es/locale/zh_CN'
function BaseForm(props,ref) {
    const form = props.form ? props.form : Form.useForm();
    const [formItemList,setFormItemList] = useState([])
    const [headers] = useState(getAuthorization());

    /**
     * 设置下拉表单option
     */
    const getOptionList = (data) => {
        if (!data) {
            return [];
        }
        let option = [];
        data.map((item) => {
            option.push(<Option key={item.name + item.id} value={item.id}>{item.name}</Option>)
        });
        return option;
    }
    /**
     * 设置单选框
     */
    const getRadioList = (data) => {
        if (!data) {
            return [];
        }
        let option = [];
        data.map((item) => {
            option.push(<Radio key={item.title+item.id} value={item.key}>{item.title}</Radio>)
        });
        return option;
    }
    /**
     * 设置树形下拉框的值
     */
    const getTreeSelectList = (data) => {
        if (!data) {
            return [];
        }
        let option = [];
        data.map((item) => {
            const i = <TreeNode key={item.id} title={item.title} value={item.id} node={item} childNum={item.childNum} isLeaf={item.isLeaf}>{getTreeSelectList(item.children)}</TreeNode>
            option.push(i)
        });
        return option;

    }
    // 设置初始值
    const initValue = (list) => {
        const formList = list?list:props.formList;
        if (formList && formList.length > 0) {
            formList.forEach((item) => {
                form.setFieldsValue(
                    {
                        [`${item.key}`]: item.value
                    }
                )
            })
        }
    }
    const setItemValue = (key,value) => {
        form.setFieldsValue(
            {
                [`${key}`]: value
            }
        )
    }
    /**
     * 组装表单
     * @returns {[]}
     */
    const initFormList = (list) => {
        const formList = list ? list : props.formList;
        const formItemList = [];
        if (formList && formList.length > 0) {
            formList.forEach((item,index) => {
                let label = item.label;
                let key = item.key;
                const rules = item.rules ? item.rules : []
                const layout = item.layout ? item.layout : {
                    labelCol: {
                        span: 6
                    },
                    wrapperCol: {
                        span: 17
                    }
                }
                const itemColSpan = item.colSpan ? item.colSpan: 12
                let placeholder = item.placeholder;
                let disabled = item.disabled;
                if (item.type === 'INPUT') {
                    const INPUT =<Col key={'col_'+index} span={itemColSpan}>
                        <Form.Item {...layout} label={label} name={key} rules={rules}>
                            <Input disabled={disabled} key={key} placeholder={placeholder} {...item.options}/>
                        </Form.Item>
                        <span style={{float: 'right',marginRight: '-18px', marginTop:'-48px'}}>{item.company ? item.company : ''}</span>
                    </Col>;
                    formItemList.push(INPUT);
                } else if (item.type === 'TEXTAREA') {
                    const INPUT =<Col key={'col_'+index} span={itemColSpan}>
                        <Form.Item {...layout} label={label} name={key} rules={rules}>
                            <Input.TextArea disabled={disabled} key={key} placeholder={placeholder} style={{width: '100%'}} {...item.options}/>
                        </Form.Item>
                    </Col>;
                    formItemList.push(INPUT);
                } else if (item.type === 'INPUT_NUMBER') {
                    const INPUT =<Col key={'col_'+index} span={itemColSpan}>
                        <Form.Item {...layout} label={label} name={key} rules={rules}>
                            <InputNumber disabled={disabled} key={key} placeholder={placeholder} style={{width: '100%'}} {...item.options}/>
                        </Form.Item>
                    </Col>;
                    formItemList.push(INPUT);
                } else if (item.type === 'SELECT') {
                    const SELECT = <Col key={'col_'+index} span={itemColSpan}>
                        <Form.Item {...layout} label={label} name={key} rules={rules}>
                        <Select disabled={disabled} mode={item.mode ? item.mode : null} key={key} placeholder={placeholder} onChange={item.select} labelInValue={item.labelInValue ? item.labelInValue : false} {...item.options}>
                            {getOptionList(item.list)}
                        </Select>
                    </Form.Item>
                    </Col>
                    formItemList.push(SELECT);
                } else if (item.type === 'TREE_SELECT') {
                    const TREE_SELECT =<Col key={'col_'+index} span={itemColSpan}>
                        <Form.Item {...layout} label={label} name={key} rules={rules}>
                        <TreeSelect disabled={disabled} key={key} loadData={item.onLoadData} placeholder={placeholder} onChange={item.select} {...item.options}>
                            {getTreeSelectList(item.list)}
                        </TreeSelect>
                    </Form.Item>
                    </Col>
                    formItemList.push(TREE_SELECT);
                } else if (item.type === 'RADIO') {
                    const SELECT = <Col key={'col_'+index} span={itemColSpan}>
                        <Form.Item {...layout} label={label} name={key} rules={rules}>
                        <Radio.Group disabled={disabled} key={key} {...item.options}>
                            {getRadioList(item.list)}
                        </Radio.Group>
                    </Form.Item>
                    </Col>
                    formItemList.push(SELECT);
                } else if (item.type === 'DATEPICKER') {
                    const datePicker = <Col key={'col_'+index} span={itemColSpan}>
                        <Form.Item label={label} name={key} rules={rules} {...layout}>
                        <DatePicker disabled={disabled} format={item.format ? item.format : 'YYYY-MM-DD HH:mm:ss'} key={key} placeholder={placeholder} rules={rules} showTime {...item.options}/>
                    </Form.Item>
                    </Col>
                    formItemList.push(datePicker);
                } else if (item.type === 'CHECKBOX') {
                    const CHECKBOX = <Col key={'col_'+index} span={itemColSpan}>
                        <Form.Item {...layout} label={label} name={key} rules={rules}>
                        <Checkbox disabled={disabled} key={key} {...item.options}>
                            {label}
                        </Checkbox>
                    </Form.Item>
                    </Col>
                    formItemList.push(CHECKBOX);
                } else if(item.type === 'TIME_INTERVAL'){
                    const begin_time = <Col key={'col_'+index} span={itemColSpan}>
                        <Form.Item {...layout} label={label} name={key} rules={rules}>
                        <DatePicker disabled={disabled} format={item.format ? item.format : 'YYYY-MM-DD HH:mm:ss'} key={key} placeholder={placeholder} showTime {...item.options}/>
                    </Form.Item>
                    </Col>
                    formItemList.push(begin_time);
                    const end_time = <Col key={'col_'+index} span={itemColSpan}>
                        <Form.Item {...layout} colon={false} key={key} label="~" name={key} rules={rules}>
                        <DatePicker disabled={disabled} format={item.format ? item.format : 'YYYY-MM-DD HH:mm:ss'} placeholder={label} showTime {...item.options}/>
                    </Form.Item>
                    </Col>
                    formItemList.push(end_time)
                } else if (item.type === 'INPUT_PASSWORD'){
                    const INPUT =<Col key={'col_'+index} span={itemColSpan}>
                    <Form.Item {...layout} label={label} name={key} rules={rules}>
                        <Input.Password disabled={disabled} key={key} placeholder={placeholder} {...item.options}/>
                    </Form.Item>
                    </Col>
                    formItemList.push(INPUT);
                } else if (item.type === 'DIVIDER'){
                    const el = <Divider key={item.key} {...item.options}/>
                    formItemList.push(el);
                } else if(item.type === 'RANGE_PICKER'){
                    const RANGE_PICKER = <Col key={'col_'+index} span={itemColSpan}>
                        <Form.Item  {...layout} label={label} name={key} rules={rules}>
                            <DatePicker.RangePicker {...item.options} key={key} placeholder={placeholder}/>
                        </Form.Item>
                    </Col>
                    formItemList.push(RANGE_PICKER);
                } else if(item.type === 'UPLOAD_IMG') {
                    const uploadButton = (
                        <div>
                          <PlusOutlined />
                          <div style={{ marginTop: 8 }}>上传图片</div>
                        </div>
                      );
                    const UPLOAD_IMG = <Col key={'col_'+index} span={itemColSpan}>
                        <Form.Item  {...layout} label={label} name={key} rules={rules}>
                            {/* <DatePicker.RangePicker {...item.options} key={key} placeholder={placeholder}/> */}
                            <Upload
                                action={`${React.$util.getBaseUrl()}/file/upload`}
                                listType="picture-card"
                                headers={headers}
                                fileList={item.list}
                                maxCount={item.maxCount}
                                onPreview={item.handlePreview}
                                onChange={item.handleChange}
                                {...item.options}
                            >
                                {
                                    item.options&&item.options.limits ?  item.list.length >= item.options.limits ? null : uploadButton : uploadButton
                                }
                            </Upload>
                            <Modal
                                visible={item.previewVisible}
                                title={item.previewTitle}
                                footer={null}
                                onCancel={item.handleCancel}
                            >
                                <img alt="example" style={{ width: '100%' }} src={item.previewImage} />
                            </Modal>
                        </Form.Item>
                    </Col>
                    formItemList.push(UPLOAD_IMG);
                } else if(item.type === 'UPLOAD_FILE'){
                    const RANGE_PICKER = <Col key={'col_'+index} span={itemColSpan}>
                        <Form.Item  {...layout} label={label} name={key} rules={rules}>
                            <Upload
                                action={`${React.$util.getBaseUrl()}/file/upload`}
                                headers={headers}
                                fileList={item.fileList}
                                {...item.options}
                            >
                                <Button icon={<UploadOutlined />}>选择文件</Button>
                            </Upload>
                        </Form.Item>
                    </Col>
                    formItemList.push(RANGE_PICKER);
                }else if(item.type === 'OTHERS'){
                    const RANGE_PICKER = <Col key={'col_'+index} span={itemColSpan}>
                        <Form.Item  {...layout} label={label} name={key} rules={rules}>
                            {item.html}
                        </Form.Item>
                    </Col>
                    formItemList.push(RANGE_PICKER);
                }
            });
            setFormItemList(formItemList)
            // return formItemList;
        }
    }
    useImperativeHandle(ref, () => ({
        resetFormValue: (formList) => {
            if (formList && formList.length > 0) {
                formList.forEach((item) => {
                    if(item.value) {
                        form.setFieldsValue(
                            {
                                [`${item.key}`]: item.value
                            }
                        )
                    }
                })
            }
        },
        initFormList: (list) => {
            initFormList(list)
        },
        initValue: initValue,
        setItemValue: (key,value)=>{
            setItemValue(key,value)
        },
        getItemValue: (key) => {
            return form.getFieldValue(key)
        }
    }))
    return (
        <Form form={form}
            name="BaseForm"
        >
            <Row>
                <ConfigProvider locale={zhCN}>
                    {formItemList}
                </ConfigProvider>
            </Row>
        </Form>
    )
}
export default forwardRef(BaseForm)
